module.exports = __webpack_public_path__ + "img/rectangle_male.547e3995.svg";